import { z } from "zod";
import { ROLES } from "../../auth/lib/roles";

// Alinhado a application.CreateAccountRequest no backend (e-mail válido, nome com pelo
// menos 2 caracteres, perfil user/admin/superadmin). Quem pode criar qual perfil é regra
// do backend; o formulário só oferece os perfis permitidos (creatableRoles).
export const createAccountSchema = z.object({
  email: z.string().trim().email("Informe um e-mail válido"),
  fullName: z.string().trim().min(2, "Informe o nome completo"),
  role: z.enum(Object.values(ROLES), { message: "Escolha um perfil" }),
});
